import { Component, OnInit, OnDestroy } from '@angular/core';
import { ClientMainBarService } from 'src/app/layout/client/client-main-bar/client-main-bar.service';
import { ApplymentModel } from 'src/app/core/services/client-general-settings/applyment/applyment.model';
import { ProcessSelectionService } from '@app/services/applyment/process-selection/process-selection.service';
import { Router, ActivatedRoute } from '@angular/router';
import { convertToInt } from '@shared/utils/util';
import { environment } from '@env';
import { StartApplymentService } from '@app/services/applyment/process-selection/start-applyment/start-applyment.service';
import { StepsModel } from '@modules/client/registration-steps/pages/registration-steps-page/services/steps.model';
import { ClientLoaderService } from '@shared/components/client-loader/client-loader.service';
import { MatSnackBar } from '@angular/material';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { TrackingService } from 'src/app/modules/client/services/tracking.service';
import { SelectiveProcessService } from '@app/services/general-settings/general/selective-process.service';
import { ApplymentSelectiveProcessService } from '@app/services/applyment/process-selection/applyment-selective-process/applyment-selective-process.service';

@Component({
  selector: 'app-selective-process-page',
  templateUrl: './selective-process-page.component.html',
  styleUrls: ['./selective-process-page.component.scss']
})
export class SelectiveProcessPageComponent implements OnInit {

  public customSettings: any = {
  };

  public env = environment;

  public proccessData: any = {};
  public proccessOptions: any[] = new Array();

  constructor(
    private clientMainBarService: ClientMainBarService,
    private applymentModel: ApplymentModel,
    private processSelectionService: ProcessSelectionService,
    private startApplymentService: StartApplymentService,
    private route: Router,
    private routeActive: ActivatedRoute,
    private stepsModel: StepsModel,
    private loaderService: ClientLoaderService,
    private snackBar: MatSnackBar,
    private trackingService: TrackingService,
    private applSelProcService: ApplymentSelectiveProcessService
  ) { }

  ngOnInit() {
    this.proccessOptions = this.applymentModel.getSelectiveProcess();
    this.customSettings = this.applymentModel.getSettings();
    this.initDirectLink();
  }

  private initDirectLink() {
    const idps = this.getIdPsURLParams();

    if (idps) {
      const body = {
        domain: this.getPortalDomain(),
        idps
      }

      this.applSelProcService.create(body).subscribe(({ success, data }) => {
        if (success) {
          this.redirect(data.id);
        }
      })
    }
  }

  private getIdPsURLParams() {
    return this.routeActive.snapshot.queryParamMap.get('idPs');
  }

  private getPortalDomain() {
    const domain = window.location.origin.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
    const routeParams = this.buildUriParams(this.routeActive.snapshot.params)
    return domain + '/' + routeParams;
  }

  private buildUriParams(params) {
    let response = '';
    response += params.uri1 ? '/' + params.uri1 : '';
    response += params.uri2 ? '/' + params.uri2 : '';
    response += params.uri3 ? '/' + params.uri3 : '';
    response += params.uri4 ? '/' + params.uri4 : '';
    response += params.uri5 ? '/' + params.uri5 : '';
    response += params.uri6 ? '/' + params.uri6 : '';
    response += params.uri7 ? '/' + params.uri7 : '';
    response += params.uri8 ? '/' + params.uri8 : '';
    response += params.uri9 ? '/' + params.uri9 : '';
    response += params.uri10 ? '/' + params.uri10 : '';
    response += params.uri ? '/' + params.uri : '';
    return response.indexOf('/') === 0 ? response.slice(1) : response;
  }

  /**
   * redirect
   */
  public redirect(idPs) {
    const queryParamsToClear = { idPs: null, modoTeste: null, rbSessionId: null}
    const sendBody = {
      process_id: idPs,
      execute_stage_query: 1,
      token: localStorage.getItem('token')
    };
    localStorage.setItem('process_id', idPs);
    this.startApplymentService.create(sendBody).subscribe(
      success => {
        this.stepsModel.setSteps(success.data);
        if (success.data.steps.currentStep) {
          this.trackingService.loadTrackingScript();
          localStorage.setItem('last_place_id', success.data.steps.currentStep.id);
          localStorage.setItem('last_place_type_id', "1");
          this.route.navigate(
            ['passo', success.data.steps.currentStep.id],
            {
              relativeTo: this.routeActive,
              queryParams: queryParamsToClear,
              queryParamsHandling: 'merge'
            }
          );
        } else {
          this.snackBar.openFromComponent(NotificationComponent, {
            panelClass: 'error',
            duration: 5000,
            data: {
              title: 'Atenção!',
              msg: 'Este portal está indisponível no momento, tente novamente mais tarde',
              act: 'OK',
              type: 'error'
            }
          });
        }
      },
      error => {
        this.loaderService.setChangesLoaderState(false);
        this.snackBar.openFromComponent(NotificationComponent, {
          panelClass: 'error',
          duration: 5000,
          data: {
            title: 'Atenção!',
            msg: 'Este portal está indisponível no momento, tente novamente mais tarde',
            act: 'OK',
            type: 'error'
          }
        });
      }
    );
  }
}
